// extracted by mini-css-extract-plugin
export default {"maintenance":"maintenance-template-module--maintenance--d378b","title":"maintenance-template-module--title--5d6b6"};